<template>
    <div class="task-type">
        <headers :title='titles'
                 :is_finish='is_finish'></headers>
        <div class="activity_img"
             v-if='is_show'
             @click='clickUrl'>
            <img :src="`${user_type==2?'/static/img/icon_img_1.png':'/static/img/icon_img_2.png'}`">
        </div>
        <div class="content">

            <div class="d_title">
                <span class="h2">个性化学习</span>
                <img src="./img/icon-new.png"
                     class="icon-new"
                     alt="">
            </div>
            <div class="d_con bor_bottom"
                 @click='exercises'>
                <div>
                    <img src="./img/icon_exer.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">同步习题</p>
                    <p>课时同步，学生完成后，推送个性化学习报告</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>
            <div class="d_con  spacing"
                 @click="previewed">
                <div>
                    <img src="./img/icon_united.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">单元复习</p>
                    <p>综合测试，学生完成后，推送个性化学习报告</p>
                </div>
                <img src="./img/icon_activity.png"
                     alt=""
                     v-if='isActivity'
                     class="qimo_paper">
                <div>
                    <em></em>
                </div>
            </div>
            <div class="d_title">
                <span class="h2">拓展学习</span>
            </div>
            <div class="d_con bor_bottom"
                 @click='book'>
                <div>
                    <img src="./img/icon_book.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">课文预习</p>
                    <p>课文朗读、学写字、标自然段</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>
            <div class="d_con bor_bottom"
                 @click='listen'>
                <div>
                    <img src="./img/icon_listen.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">生词听写</p>
                    <p>系统朗读,学生将听到的词语写在纸上</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>

            <div class="d_con bor_bottom"
                 @click="newtoRead">
                <div>
                    <img src="./img/icon_read.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">课外阅读</p>
                    <p>与教材同步，让孩子学会阅读</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>

            <div class="d_con bor_bottom"
                 @click="toWrong">
                <div>
                    <img src="./img/icon_wrong.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">高频错题</p>
                    <p>班级每周错误率高的试题</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>
            <div class="d_con spacing"
                v-if="inApp"
                 @click='extrac'>
                <div>
                    <img src="./img/icon_extr.png"
                         alt="">
                </div>
                <div class="d_center">
                    <p class="h3">课外活动</p>
                    <p>手抄报，做家务，自我展示等</p>
                </div>
                <div>
                    <em></em>
                </div>
            </div>

            <!-- <div class="d_title">
                <span class="h2">课外拓展</span>
            </div> -->
            <!-- <div class="d_con bor_bottom" @click="toRead">
        <div>
          <img src="./img/icon_read.png" alt="">
        </div>
        <div class="d_center" >
          <p class="h3">课外阅读</p>
          <p>阅读完成后可答题测试，培养阅读能力</p>
        </div>
        <div>
          <em></em>
        </div>
      </div> -->

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue'
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            titles: '选择作业类型',//sid:51 task_type:1课前预习2课后练习(test_type:1同步习题2单元复习3高频错题4生词听写)
            type: this.$route.query.type,
            user_type: Number(this.$route.query.user_type),
            is_show: Number(this.$route.query.is_show),
            isActivity: false,
            token: localStorage.getItem('Tbkt-Token'),
            is_finish: localStorage.getItem('subjectLength') <= 1//从本地读取教师带的科目数并判断
        }
    },
    methods: {
        book () {
            // 课文预习
            this.$router.push('/chinese/before/taskset')
        },
        listen () {
            // 生词听写
            this.$router.push('/chinese/listen/taskset')
        },
        exercises () {
            // 同步习题
            this.$router.push('/chinese/select_task/select_chapter/51/0')
        },
        previewed () {
            //单元复习
            this.$router.push('/chinese/select_task/select_chapter/51/1')
        },
        toWrong () {
            // 高频错题
            this.$router.push('/chinese/wrong/index')
        },
        toRead () {
            //课外阅读
            this.$router.push('/chinese/course/selected?sid=51')
        },
        newtoRead () {
            let user_id = JSON.parse(localStorage.getItem('info')).user_id;
            let { platform, app_version } = JSON.parse(localStorage.getItem('search'));
            location.href = `${VUE_URL_QNYD}/tea/home/2?user_id=${user_id}&tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
        },
        extrac () {
            // try{
            //   appobject.Interactive('ys_task_kwhd,51')
            // }catch(e){
            //   //console.log(e)
            // }
            this.appFunction("ys_task_kwhd", "51")
        },
        clickUrl () {
            let url = this.user_type == 1 ? `/activity/activation/active` : `/activity/activation/silent`;
            this.$router.push(url);
        },
        // tohd(){
        //   if(this.hdUrl!=''){
        //     this.$router.push(this.hdUrl+'&teahd=1');
        //   }
        // }
    },
    components: {
        headers
    },
    created () {
        localStorage.removeItem('chinese_send_ok');
        let EndTime = new Date('2020/1/31 23:59:59').valueOf();
        let today = new Date().valueOf();
        this.isActivity = today > EndTime ? false : true;


        // this.$http.post(API_URL_TASK_API + '/activity/task/').then((res) => {
        //   if (res.data.response === 'ok') {
        //     this.hdUrl= res.data.data.split(".cn")[1];
        //   }
        // })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.spacing {
    margin-bottom: 20px / $ppr;
}

.h2 {
    font-size: 30px / $ppr;
    font-weight: bold;
}

.h3 {
    font-weight: bold;
}

.bor_bottom {
    border-bottom: 1px / $ppr solid #e8e8e8;
}

.task-type {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}

.activity_img {
    height: 228px / $ppr;
    padding: 0 25px / $ppr;
    background: #fff;
    img {
        position: relative;
        top: 24px / $ppr;
        display: block;
        height: 200px / $ppr;
        z-index: 3;
    }
}

.content {
    .d_title {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding-left: 24px / $ppr;
        background: #fff;
        span {
            padding-left: 16px / $ppr;
            border-left: 4px / $ppr solid #5e89ef;
        }
        .icon-new {
            height: 30px / $ppr;
            position: relative;
            top: 4px / $ppr;
            left: 5px / $ppr;
        }
    }
    .d_con {
        height: 150px / $ppr;
        background: #fff;
        padding: 0 24px / $ppr;
        display: flex;
        display: -webkit-flex;
        position: relative;
        div {
            height: 100%;
            display: inline-block;
        }

        .qimo_paper {
            width: 136px / $ppr;
            height: 36px / $ppr;
            position: absolute;
            top: 29px / $ppr;
            left: 225px / $ppr;
        }

        div:nth-of-type(1) {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
            img {
                width: 56px / $ppr;
                height: 56px / $ppr;
                &.Stars {
                    width: 65px / $ppr;
                    height: 50px / $ppr;
                }
            }
        }
        .d_center {
            padding-left: 20px / $ppr;
            p {
                height: 75px / $ppr;
                line-height: 100px / $ppr;
                text-align: left;
            }
            p:nth-of-type(2) {
                color: gray;
                line-height: 50px / $ppr;
                font-size: 24px / $ppr;
            }
        }
        div:nth-of-type(3) {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            -webkit-justify-content: center;
            align-items: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            position: absolute;
            right: 12px / $ppr;
            em {
                display: inline-block;
                width: 30px / $ppr;
                height: 30px / $ppr;
                background: url("./img/icon_next.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
}
.font-italic {
    font-style: italic;
}
</style>
